import { colors } from '@fs/zion-ui'
import React from 'react'

export default function ChannelMembersCount({ memberCount }) {
  return (
    <span
      id="Chat Channel Members Count"
      style={{
        border: `2px solid ${colors.gray90}`,
        backgroundColor: colors.gray60,
        fontSize: '14px',
        color: colors.gray02,
        minHeight: '24px',
        minWidth: '24px',
        padding: '0 5px',
        lineHeight: '20px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {memberCount}
    </span>
  )
}
